import { render, staticRenderFns } from "./SyncResourceInfo.vue?vue&type=template&id=0a0db3fc"
import script from "./SyncResourceInfo.vue?vue&type=script&lang=js"
export * from "./SyncResourceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports